import { askGemini } from "../Intelligence/askGemini";

const instruction = `
# Summary Creation: You need to create a five-line summary of the passage you provide.The summary needs to be "elaborate".
# Complexity Level: Do not make it simpler to understand by using common synonyms nor harder. Its complexity to understand should just be slightly higher than the original passage. Do not use very complex academic words unless such words are used in the original passage.
# Goal: I will give this passage to user in a jumbled format so that they can practice Paragraph ordering. Hence, reduce the use of words like Consequently, Therefore, Thus, Finally or starting markers which will make the start or ending line too obvious.
# Below is the passage given, for which you will give FIVE LINE Summary.
`;

export async function generateValidatedParagraph(input) {
  try {
    // Call Gemini
    const response = await askGemini(instruction, input);

    if (!response || typeof response !== "string") {
      return {
        success: false,
        error: "Invalid response from Gemini",
      };
    }
    const lines = extractLines(response);

    if (lines.length !== 5) {
      return {
        success: false,
        error: `Expected 5 lines, got ${lines.length}`,
      };
    }

    // Create map/object
    const lineMap = {};

    lines.forEach((line, index) => {
      lineMap[index + 1] = line;
    });

    return {
      success: true,
      result: lineMap,
    };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      error: "Error while generating paragraph",
    };
  }
}


function extractLines(response) {
  if (!response || typeof response !== "string") {
    return [];
  }

  const cleaned = response.trim();

  // ─────────────────────────────────────────────
  // 1. Try JSON parsing first
  // ─────────────────────────────────────────────
  try {
    const parsed = JSON.parse(cleaned);

    // JSON Array
    if (Array.isArray(parsed)) {
      return parsed
        .map((item) => String(item).trim())
        .filter(Boolean);
    }

    // JSON Object
    if (typeof parsed === "object" && parsed !== null) {
      return Object.keys(parsed)
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => String(parsed[key]).trim())
        .filter(Boolean);
    }
  } catch (e) {
    // not JSON → continue
  }

  // ─────────────────────────────────────────────
  // 2. Split using newlines
  // ─────────────────────────────────────────────
  let lines = cleaned
    .split(/\n+/)
    .map((line) =>
      line
        .replace(/^\d+[).:-]?\s*/, "")
        .replace(/^[-*•]\s*/, "") // remove bullets
        .trim()
    )
    .filter(Boolean);

  // ─────────────────────────────────────────────
  // 3. If only one line → split by sentence
  // ─────────────────────────────────────────────
  if (lines.length === 1) {
    lines = lines[0]
      .split(/(?<=[.!?])\s+/)
      .map((line) => line.trim())
      .filter(Boolean);
  }

  return lines;
}